const CategoryItemData = {
    food: [
      { itemName: "Sashimi", price: 22 },
      { itemName: "Unagi-Grilled Eel", price: 22 },
      { itemName: "Soba- BuckWheat Noodles", price: 22 },
      { itemName: "Onagiri-Rice Balls", price: 22 },
      { itemName: "Yakitori- Grilled Chicken", price: 22 },
      { itemName: "Miso Soup", price: 22 },
    ],
    drink: [
      { itemName: "Amazake", price: 22 },
      { itemName: "Royal Milk Tea", price: 22 },
      { itemName: "Flavoured SoyaMilk Drinks ", price: 22 },
    ],
  };

export default CategoryItemData